import { DoctorPicker } from 'views/pickers';
import { agendaTypes } from 'shared/fixtures';
import { turnsActions } from 'core/Turns';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AgendaList, AvailableModal } from './components';
import {
    ButtonDiv,
    Col,
    Container,
    Content,
    Row
} from './styled';
import {
    ExpandButton,
    FormGroup,
    Loader,
    SelectSearch
} from 'mol-ui';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useQuery,
    useSelector
} from 'hooks';

const AgendaConfiguration = () => {

    const dispatch = useDispatch();
    const { push } = useHistory();
    const { t } = useTranslation();
    const { professional: professionalId } = useQuery();

    const {
        agendasLoading,
        availableTimesLoading,
        unavailableTimesLoading
    } = useSelector('turns');
    const loading = agendasLoading || availableTimesLoading || unavailableTimesLoading;

    const [filterType, setFilterType] = useState('');
    const [modalAvailable, setModalAvailable] = useState(false);
    const [modalUnavailable, setModalUnavailable] = useState(false);
    const [professional, setProfessional] = useState(0);

    useEffect(() => {
        dispatch(turnsActions.setTurnsAgendas([]));
    }, []);

    useEffect(() => {
        handleDoctorChange(professionalId ? Number(professionalId) : 0);
    }, [professionalId]);

    const handleDoctorChange = id => {
        const data = {
            doctor_id: id
        };
        dispatch(turnsActions.getSchedule(data));
        setProfessional(id);
    };

    return (
        <Container>
            <AvailableModal
                active={ modalAvailable || modalUnavailable }
                available={ modalAvailable }
                doctor={ professional || 0 }
                onToggle={ modalAvailable ? () => setModalAvailable(false) : () => setModalUnavailable(false) }
            />
            <Content>
                <Row>
                    <Col lg="4" md="6">
                        <FormGroup label={ t('Seleccione el perfil a configurar') }>
                            <DoctorPicker
                                margin="10px 0px"
                                nullPlaceholder={ t('Para todos los profesionales') }
                                value={ professional || 0 }
                                onChange={ handleDoctorChange }
                            />
                        </FormGroup>
                    </Col>
                    <Col lg={{ offset: 4, size: 4 }} md="6">
                        <SelectSearch
                            margin="0px 0px 10px auto"
                            options={ agendaTypes }
                            placeholder={ t('Filtrar por tipo') }
                            value={ filterType }
                            width="200px"
                            onChange={ setFilterType }
                        />
                    </Col>
                </Row>
                {
                    !loading
                        ? <AgendaList doctorId={ professional } filter={ filterType } />
                        : <Loader active={ true } />
                }
            </Content>
            <ButtonDiv>
                <ExpandButton
                    caption={ t('Nuevo horario no disponible') }
                    size={ 150 }
                    onClick={ () => setModalUnavailable(true) }
                />
                {
                    professional !== 0 &&
                    <>
                        <ExpandButton
                            caption={ t('Nuevo horario disponible') }
                            size={ 150 }
                            onClick={ () => setModalAvailable(true) }
                        />
                    </>
                }
                <ExpandButton
                    caption={ t('Nueva agenda') }
                    size={ 150 }
                    onClick={ () => push(`${ t('/agenda/crear') }${ professional ? `?professional=${ professional }` : '' }`) }
                />
            </ButtonDiv>
        </Container>
    );
};

export default AgendaConfiguration;
